import { useQuery, UseQueryResult } from "react-query";
import api from "../../service/api";

export type Concept = {
  cod: number;
  description: string;
};

export type ConceptFilters = {
  cod?: number;
  isActive?: number;
};

export async function getConcepts(
  filters?: ConceptFilters
): Promise<Concept[]> {
  const { data } = await api.get<{ contents: Concept[] }>("/concept", {
    params: filters,
  });

  return data.contents;
}

export function useConcepts(
  filters?: ConceptFilters
): UseQueryResult<Concept[]> {
  return useQuery(["concepts"], () => getConcepts(filters), {
    staleTime: 1000 * 60 * 10, // 10 Minutos
  });
}
